"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttributeExpandManager = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const table_columns_1 = require("../../../../common/table-columns");
const product_table_dynamic_columns_1 = require("../../../../hooks/product-table-dynamic-columns");
const models_1 = require("../../../../models");
const products_table_1 = require("../../../../store/catalogs/products-table");
const utils_1 = require("../../../../utils");
const store_1 = require("../../../../../store");
const useAttributeExpandManager = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const catalogId = (0, store_1.useSelectedCatalogId)();
    const selectedAttributeNode = (0, store_1.useSelectedAttributeNode)();
    const excludedItems = (0, store_1.useExpandedAttributes)();
    const collapseState = (0, store_1.useAttributesCollapseState)();
    const persistedReviewAttributeColumnData = (0, products_table_1.useProductsTableDynamicColumns)();
    const setPersistedReviewAttributeColumnData = (0, react_1.useCallback)((data) => {
        dispatch((0, products_table_1.setProductsDynamicTableColumns)(catalogId, data));
    }, [dispatch, catalogId]);
    const { onToggleReviewAttributeColumn, onRemoveReviewAttributeColumn, onResetReviewAttributeColumn, } = (0, product_table_dynamic_columns_1.useReviewAttributeColumnManager)({
        persistedData: persistedReviewAttributeColumnData,
        setPersistedData: setPersistedReviewAttributeColumnData,
    });
    const [_, startTransition] = (0, react_1.useTransition)();
    const isAtLeastOneExpanded = !(collapseState === models_1.CollapseState.Collapse && !excludedItems.length);
    const toggleExpandAll = (0, react_1.useCallback)(() => {
        startTransition(() => {
            dispatch((0, store_1.enrichAISetAttributeCollapseState)(isAtLeastOneExpanded ? models_1.CollapseState.Collapse : models_1.CollapseState.Expand));
        });
        dispatch((0, store_1.enrichAISetAttributesExcludedItems)([]));
        if (isAtLeastOneExpanded) {
            onResetReviewAttributeColumn();
        }
    }, [dispatch, isAtLeastOneExpanded, onResetReviewAttributeColumn]);
    const toggleExpand = (0, react_1.useCallback)((item, expanded) => {
        const { label, isMeasure, isAIEnriched } = item;
        const value = (collapseState === models_1.CollapseState.Expand && !expanded) || (collapseState === models_1.CollapseState.Collapse && expanded);
        dispatch((0, store_1.enrichAISetAttributesExcludedItems)((0, utils_1.updateUniqueItemListBasedOnValue)(label, value)(excludedItems)));
        const id = (0, table_columns_1.createColumnId)(label, { isMeasure, isAIEnriched });
        if (value) {
            onToggleReviewAttributeColumn(id);
        }
        else {
            onRemoveReviewAttributeColumn(id);
            if ((selectedAttributeNode === null || selectedAttributeNode === void 0 ? void 0 : selectedAttributeNode.label) === label) {
                dispatch((0, store_1.enrichAISetSelectedAttributeNode)(null));
            }
        }
    }, [collapseState, dispatch, excludedItems, onRemoveReviewAttributeColumn, onToggleReviewAttributeColumn, selectedAttributeNode]);
    const checkIsExpanded = (0, react_1.useCallback)((item) => {
        const isExcluded = excludedItems.includes(item);
        return collapseState === models_1.CollapseState.Collapse ? isExcluded : !isExcluded;
    }, [collapseState, excludedItems]);
    return {
        isAtLeastOneExpanded,
        toggleExpandAll,
        toggleExpand,
        checkIsExpanded,
    };
};
exports.useAttributeExpandManager = useAttributeExpandManager;
